import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React, { useMemo } from 'react';
import { withRef } from '../../utils';
export const Input = withRef(function Input({ id: initialId, type = 'text', invalid, className, ...restProps }, ref) {
    const { disabled, touched } = useField();
    const id = useMemo(() => `castor_input_${++idCount}`, [initialId]);
    return (React.createElement("input", { disabled: disabled, ...restProps, ref: ref, id: id, type: type, className: classy(c('input'), m({ invalid, touched }), className) }));
});
let idCount = 0;
//# sourceMappingURL=input.js.map